import React, { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const SearchSection = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchQuery, setSearchQuery] = useState(searchParams.get('search') || '');

  const handleSearch = useCallback(() => {
    const params = new URLSearchParams();
    if (searchQuery.trim()) {
      params.set('search', searchQuery.trim());
    }
    params.delete('page'); // Reset to first page for new searches
    setSearchParams(params);
  }, [searchQuery, setSearchParams]);

  // Debounced search
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (searchQuery !== (searchParams.get('search') || '')) {
        handleSearch();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [searchQuery, handleSearch, searchParams]);

  return (
    <div className="search-section">
      
      <div className="search-form">
        <div className="search-input">
          <input
            type="text"
            className="form-control"
            placeholder="Search by company, industry or keyword"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSearch();
              if (e.key === 'Escape' && searchQuery) setSearchQuery('');
            }}
          />
          {searchQuery && (
            <button
              type="button"
              className="ds-search-clear"
              onClick={() => setSearchQuery('')}
              aria-label="Clear search"
            >
              <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M18 6 6 18M6 6l12 12" stroke="currentColor" strokeWidth="2"
                      strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          )}
        </div>
        <div className="search-button">
          <button
            type="button"
            className="btn"
            onClick={handleSearch}
            aria-label="Search"
          >
            <svg className="ds-search-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
              <path d="m20 20-4.35-4.35" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span className="ds-search-button-text">Search</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchSection;
